import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/DAWNING/index'
import aboutUs from '@/components/DAWNING/aboutUs'
import caseShow from '@/components/DAWNING/caseShow'
import serviceProject from '@/components/DAWNING/serviceProject'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/serviceProject',
      name: 'serviceProject',
      component: serviceProject
    },
    {
      path: '/caseShow',
      name: 'caseShow',
      component: caseShow,
    }
  ],
  linkExactActiveClass: 'active'
})



// WEBPACK FOOTER //
// ./src/router/dawingIndex.js